import { AST } from '@handlebars/parser';
import { NodeType } from '../../node/types';
import { DEFAULT_LOCATION as loc } from '../../source/location';

export const createHash = (pairs: AST.Hash['pairs'] = []): AST.Hash => ({
  type: NodeType.Hash,
  loc,
  pairs,
});
